import { addressClient } from "@core/clients";
import { Address } from "@core/types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { queryClient } from "../../config/query-client";

type Props = {
  addressId: Address["id"];
};

type Options = UseMutationOptions<Address["id"] | null, unknown, Props, string[]>;

const useGetCustomerAddresses = (options?: Options) => {
  return useMutation(
    ["customer-address", "delete"],
    async ({ addressId }) => {
      return addressClient.deleteCustomerAddress(addressId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["customer-address", "get"]);
      },
      ...options,
    }
  );
};

export default useGetCustomerAddresses;
